// src/components/Modal.js
import React from 'react';
import { useLocale } from '../context/LocaleContext';

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  size = 'md',
  backdropClassName = '',
  containerClassName = ''
}) => {
  const { t } = useLocale();

  if (!isOpen) return null;

  // Define size classes (can be extended)
  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-xl', // Adjusted for potentially longer descriptions
    lg: 'max-w-3xl',
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-sm ${backdropClassName}`}
    >
      {/* The modal container */}
      <div
        className={`relative bg-slate-900/60 rounded-[2rem] p-2 shadow-2xl border border-white/10 backdrop-blur-2xl w-full ${sizeClasses[size]} max-h-[100vh] overflow-hidden flex flex-col ${containerClassName}`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal content
      >
        {/* Modal header */}
        <div className="flex items-center justify-between p-4 border-b border-white/10 flex-shrink-0">
          {title && <h3 className="text-xl font-bold text-white">{title}</h3>}
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors duration-200 focus:outline-none"
            aria-label={t('modal.close', 'Close')}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        {/* Modal body - this will be scrollable if content is long */}
        <div className="p-4 flex-1 min-h-0 overflow-y-auto overscroll-contain">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
